
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import useAppState from '../../context/AppContext';
import * as Yup from 'yup';
import { ChangeEvent, useState } from 'react';
import LoaderModal from '../../modals/common/LoaderModal';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import { IApiErrors,  } from '../../context/model';
import { getFilename, handleKeyDown, isAcceptedFileSize, isAcceptedFileSizeMultiple, isValidFileSize, isValidFileType } from '../../utils/utils';
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { AxiosError } from 'axios';
import MgpInputFileUpload from '../../elements/MgpInputFileUpload/MgpInputFileUpload';
import ListOfFileUploaded from './ListOfFileUploaded';
import { ERROR_MESSAGES, PROPOSITION_DOC_TYPES } from '../../const/AppConst';
import Modal from 'react-modal';
import { compressFile, mergeFile } from '../../services/CustomerApiService';


type UploadMultipleComponentProps = {
    isOpen: boolean,
    onCloseModal: () => void,
    onUploadAction: (fileToUpload: File) => void,
    docType: string,
    accessToken?: string,
    setHasMultipleFile?: (response: boolean) => void,

}

type AddStep0FormData = {
}

export default function UploadMultipleComponent({isOpen, onCloseModal, onUploadAction, docType, accessToken, setHasMultipleFile}: UploadMultipleComponentProps) {

  const {
    state: { jwtToken },
  } = useAppState();

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<boolean | null>();
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<boolean | null>();
  const [file, setFile] = useState<File | null>(null);
  const [openPreviewFile, setOpenPreviewFile] = useState<boolean>(false);
  const [showUploadButton, setShowUploadButton] = useState<boolean>(false);
  const [files, setFiles ] = useState<File[]>([]);
  const [replacing, setReplacing] = useState<number | null>(null);

  const validationSchema = Yup.object().shape({
  });

  const {
    register,
    formState: { errors },
  } = useForm<AddStep0FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {

    },
    resolver: yupResolver(validationSchema),
  });


  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    try {
        const uploadedfile = event.target.files?.[0];

        if (uploadedfile) {
            if(!isValidFileType(uploadedfile)) {
              setErrorFileTypeMsg(true);
            } else if (!isAcceptedFileSize(uploadedfile)) {
              setErrorFileSizeMsg(true);
            } else if(!isAcceptedFileSizeMultiple(uploadedfile)) {
              if(uploadedfile.type === 'application/pdf') {
                   setOpenPreviewFile(true);
                   setShowUploadButton(true);
                   setFile(uploadedfile);                  
              } else {
                try {
                  const token = accessToken ?? jwtToken!.accessToken;
                  const res = await compressFile(token, uploadedfile);
                  const content = res.data as Blob;
                  const filename= getFilename(res.headers);
                  const newFile = new File([content], filename, {type: uploadedfile.type});
                  setOpenPreviewFile(true);
                  setShowUploadButton(true);
                  setFile(newFile);
                } catch(e) {
                  setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
                } 
              }
            } else {
                setOpenPreviewFile(true);
                setShowUploadButton(true);
                setFile(uploadedfile);
            }
        } else {
            setErrorMsg('Il y a une erreur sur votre téléchargement. Merci de réessayer');
        } 
    }  catch (error) {
        const err = error as AxiosError;
        console.log(err);
        if(err.response && err.response.status === 400) {
          const errorData = err.response?.data as IApiErrors;
          setErrorMsg("Erreur: " + errorData.message);
        } else {
          setErrorMsg("Une erreur technique est survenue ");
        }
    }
  };

  const onConfirmAction = () => { 
    setOpenPreviewFile(false);
    setErrorFileTypeMsg(false);
    setErrorFileSizeMsg(false);
    if (file) { 
        setFiles([...files, file]);
        setFile(null);
        setReplacing(null);
    }
  }

  const handleClosePreviewModal = () => {
    setOpenPreviewFile(false);
    setFile(null);
    setReplacing(null);
  }

  const onConfirmUploadAction = async () => {
    setErrorMsg(null);
    setErrorFileTypeMsg(false);
    setLoading(true);
    try {

      let newFile;
      if (files.length > 1) {
        const token = accessToken ?? jwtToken!.accessToken;

        const mergeRes = await mergeFile(token, files);
        setLoading(false);
        setFile(null);
        const content = mergeRes.data as Blob;
        const filename= getFilename(mergeRes.headers);
        newFile = new File([content], filename, { type: "application/pdf"});
        if (setHasMultipleFile) {
          setHasMultipleFile?.(true)
        }
      } else {
        newFile = files[0];
        if (setHasMultipleFile) {
          setHasMultipleFile?.(false)
        }
      }
  
      onUploadAction(newFile);
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Vos fichiers sont trop lourds ou invalides");
      }
    }
  }

  const onDownLoadDocument = async (file: File) => {
      setFile(file);
      setOpenPreviewFile(true);
      setShowUploadButton(false);
  }

  const onDeleteDocument = async (index: number) => {
    if (index !== -1) {
        const newArr = [...files];
        newArr.splice(index, 1);
        setFiles(newArr);
    } else {
        setErrorMsg('Une erreur est survenue')
    }
  }

  const onReplaceDocument = async (event: ChangeEvent<HTMLInputElement>, i: number) => {
    const uploadedfile = event.target.files?.[0];
    if (uploadedfile) {
        if(!isValidFileType(uploadedfile)) {
            setErrorFileTypeMsg(true);
        } else if (!isValidFileSize(uploadedfile)) {
          setErrorFileSizeMsg(true);
        } else if(!isAcceptedFileSizeMultiple(uploadedfile)) {
          if(uploadedfile.type === 'application/pdf') {
            setOpenPreviewFile(true);
            setShowUploadButton(true);
            setFile(uploadedfile);                  
       } else {
          try {
            const token = accessToken ?? jwtToken!.accessToken;

            const res = await compressFile(token, uploadedfile);
            const content = new Blob([res.data], {type: res.headers['content-type']});
            const filename= getFilename(res.headers);
            const newFile = new File([content], filename);
            setOpenPreviewFile(true);
            setShowUploadButton(true);
            setFile(newFile);
            setReplacing(i);
          } catch(e) {
            setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
          } 
        }
        } else {
            setOpenPreviewFile(true);
            setShowUploadButton(true);
            setFile(uploadedfile);
            setReplacing(i);
        }
    } else {
        setErrorMsg('Il y a une erreur sur votre téléchargement. Merci de réessayer');
    } 
  
  }

  const onConfirmReplaceDocument = () => {
    if (replacing !== null && replacing !== -1 && file) {
        const newArr = [...files];
        newArr.splice(replacing, 1, file);
        setFiles(newArr);
    } else {
        setErrorMsg('Une erreur est survenue');
    }
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
        <div className='modale open'>
            <div className="modale--content">
                <div className="modale--content--template">
                    <div className= "modale--main-width-entreprise shadow-bleu pb-lg bg-glace" >
                        <form className="p-x-lg p-y-lg">
                            <p className='card-title bleu'>{PROPOSITION_DOC_TYPES.find(el => el.code === docType)?.label }</p>
                            <p className='text mb-md'>Veuillez télécharger votre document. Si votre document comporte plusieurs pages, veuillez sélectionner chaque page puis cliquez sur "Confirmer" pour les télécharger ou cliquez sur "Annuler" pour revenir à tout moment à la page principale. </p>

                            <div>
                                { errorFileTypeMsg && <MgpMessage type="danger" message={ERROR_MESSAGES.fileTypeMsg} hasCloseBtn={false}/> }
                                { errorFileSizeMsg && <MgpMessage type="danger" message={ERROR_MESSAGES.fileSizeMsg} hasCloseBtn={false}/> }
                            </div> 

                            <div>
                                { errorMsg && 
                                <MgpMessage 
                                  type="danger" 
                                  message={errorMsg} 
                                  hasCloseBtn={true} 
                                  onCloseErrHandler={()=> setErrorMsg('')}
                                /> 
                                }
                            </div> 

                            <div className="form-row">
                                <div className="form-group mw-40">
                                    <MgpInputFileUpload
                                        id="file"
                                        onChange={handleFileChange}
                                        register={register} 
                                        errors={errors}
                                        onClick={(e)=> e.currentTarget.value = ''}
                                        isUploadMultiple={true}
                                    /> 
                                </div>
                                <div className='form-group mw-60'>
                                    { files && files.length > 0 && <p className='fw-medium fz-lg bleu m-y-lg '>{files.length > 1 ? "Vos fichiers : " : "Votre fichier : "}</p>}
                                    { files && files.length > 0 && files.map((fileUploaded, i) =>
                                          <div className='m-y-xs' key={i}> 
                                            <ListOfFileUploaded 
                                                fileName={fileUploaded.name}
                                                onDownloadDocument={() => onDownLoadDocument(fileUploaded)}
                                                onDeleteDocument={() => onDeleteDocument(i)}
                                                onHandleFileChangeReplace={(e) => onReplaceDocument(e, i)}
                                                
                                            /> 
                                          </div>      
                                    )}
                                    
                                </div>
                            </div>

                            <div className="mt-lg ta-center buttons-bloc">
                                <a className='cta-inline-bleu m-x-lg' onClick={onCloseModal} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Annuler</a>   
                                {files && files.length > 0 && <a className='cta-bleu m-x-lg' onClick={onConfirmUploadAction} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Confirmer</a>}
                            </div>
                            
                            
                        </form>

                        { openPreviewFile && file && replacing === null && <UploadFilePreviewModal file={file} onUploadAction={onConfirmAction} isOpen={openPreviewFile} onCloseModal={handleClosePreviewModal} showButton={showUploadButton}/>} 
                        { openPreviewFile && replacing !== null && file && <UploadFilePreviewModal file={file} onUploadAction={onConfirmReplaceDocument} isOpen={openPreviewFile} onCloseModal={handleClosePreviewModal} showButton={showUploadButton}/>} 
                        { loading && <LoaderModal hasMessage={true} message='Vos fichiers sont en train de fusionner et uploader'/> }
                         
                    </div>
                </div>
            </div>
        </div>
    </Modal>
  
  )
}
